import Vue from 'vue'
import Router from 'vue-router'
import {
	getEventBus
} from "../api/eventBus"
Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}

var router = new Router({
	mode: 'history',
	scrollBehavior: (to, from, savedPosition) => {
		if (savedPosition) {
			return savedPosition
		} else {
			// 返回顶部
			return {
				x: 0,
				y: 0
			}
		}
	},

	routes: [{
			path: '/gonggaoList',
			component: () => import('@/views/gonggaoList.vue'),
			meta: {
				title: '公告'
			},
		},
		{
			path: '/dyKnowlege',
			component: () => import('@/views/dyKnowlege.vue'),
			meta: {
				title: '更多'
			},
		},
		{
			path: '/reportComplaints',
			component: () => import('@/views/reportComplaints.vue'),
			meta: {
				title: '举报投诉'
			},
		},

		{
			path: '/myCollection',
			component: () => import('@/views/myCollection.vue'),
			meta: {
				title: '我的收藏'
			},
		},
		{
			path: '/myAttention',
			component: () => import('@/views/myAttention.vue'),
			meta: {
				title: '我的关注'
			},
		},
		{
			path: '/myComment',
			component: () => import('@/views/myComment.vue'),
			meta: {
				title: '我的评价'
			},
		},
		{
			path: '/myCaseList',
			component: () => import('@/views/myCaseList.vue'),
			meta: {
				title: '我的案件'
			},
		},
		{
			path: '/dyPanli',
			component: () => import('@/views/dyPanli.vue'),
			meta: {
				title: '道佑判例'
			},
		},
		{
			path: '/newsInfoDetail',
			component: () => import('@/views/newsInfoDetail.vue'),
			meta: {
				title: '资讯详情'
			},
		},
		{
			path: '/newsInformation',
			component: () => import('@/views/newsInformation.vue'),
			meta: {
				title: '最新资讯'
			},
		},
		{
			path: '/login',
			component: () => import('@/views/login.vue'),
			meta: {
				title: '登录',
				noBack: true

			},
		},
		{
			path: '/',
			component: () => import('@/views/home.vue'),
			meta: {
				title: '首页'
			},
		}, {
			path: '/cooperate',
			component: () => import('@/views/cooperate.vue'),
			meta: {
				title: '招贤纳氏'
			},
		}, {
			path: '/affairs',
			component: () => import('@/views/affairs.vue'),
			meta: {
				title: '商务合作'
			},
		}, {
			path: '/layout',
			component: () => import('@/views/layout.vue'),
			meta: {
				title: '自主研发ERP'
			},
		}, {
			path: '/layoutOne',
			component: () => import('@/views/layoutOne.vue'),
			meta: {
				title: '道佑培训平台'
			},
		}, {
			path: '/esg',
			component: () => import('@/views/esg.vue'),
			meta: {
				title: 'E.S.G'
			},
		},
		{
			path: '/serveStart',
			component: () => import('@/views/serveStart.vue'),
			meta: {
				title: '服务之星榜'
			},
		},
		{
			path: '/qiandanxibao',
			component: () => import('@/views/qiandanxibao.vue'),
			meta: {
				title: '签单喜报'
			},
		}, {
			path: '/about',
			component: () => import('@/views/about.vue'),
			meta: {
				title: '关于我们'
			},
		}, {
			path: '/upload',
			component: () => import('@/views/upload.vue'),
			meta: {
				title: '下载和关注'
			},
		}, {
			path: '/search',
			component: () => import('@/views/search.vue'),
			meta: {
				title: '搜索'
			},
		}
	]
})

// // 全局前置守卫
// router.beforeEach((to, from, next) => {
//   // 检查即将离开的路由是否有noBack标记
//   if (from.meta && from.meta.noBack) {
//     // 如果不允许返回，则重定向到首页或其他页面
//     next('/');
//   } else {
//     // 否则允许导航
//     next();
//   }
// });

router.afterEach((to, from) => {
	console.log("from", from);
	console.log("我跳转完了", to);
	$(function() {
		let toTitle = to.meta.title
		let formTitle = from.meta.title
		console.log('formTitle: ', formTitle);
		if (toTitle == '首页') {

			getEventBus().$emit("scrollToTopLast")
		}
		if (formTitle == '首页') {

			getEventBus().$emit("saveCurrent")
		}
		setTimeout(() => {
			if (to.query.id) {
				$("html,body").animate({
					scrollTop: 0
				}, 1);
				$('html , body').animate({
					scrollTop: $('#' + to.query.id).offset().top - 150
				}, 1000);
			} else {
				$("html,body").animate({
					scrollTop: 0
				}, 1);
			}
		}, 500)
	})
})
// const scrollBehavior = (to, from, savedPosition) => {
// 	if (savedPosition) {
// 		// 如果savedPosition存在，即返回到一个已保存的位置
// 		return savedPosition;
// 	} else {
// 		// 如果没有savedPosition，返回到顶部
// 		return {
// 			x: 0,
// 			y: 0
// 		};
// 	}
// };

// router.onReady(() => {
// 	// 在应用准备就绪后，将scrollBehavior应用到路由器实例上
// 	router.scrollBehavior = scrollBehavior;
// });
export default router


// WEBPACK FOOTER //
// ./src/router/index.js